import { asset } from '../components/UI';
export function getProducts(t) {
  return [{
    id: 'kids',
    name: t("beef_rendang_for_kids"),
    category: t("for_little_ones"),
    price: 45000,
    image: 'sapi.jpeg',
    description: t("mild_beef_rendang_to_accompany_your_little_ones_meals")
  }, {
    id: 'belut',
    name: t("eel_rendang_for_kids"),
    category: t("for_little_ones"),
    price: 45000,
    image: 'belut.jpeg',
    description: t("flavourful_eel_rendang_prepared_especially_for_children")
  }, {
    id: 'tuna',
    name: t("tuna_rendang_for_kids"),
    category: t("for_little_ones"),
    price: 40000,
    image: 'tuna.jpeg',
    description: t("tuna_in_a_mild_rendang_recipe_for_little_ones")
  }, {
    id: 'lele',
    name: t("catfish_rendang_for_kids"),
    category: t("for_little_ones"),
    price: 35000,
    image: 'lele.jpeg',
    description: t("catfish_rendang_to_add_variety_to_your_little_ones")
  }, {
    id: 'satset',
    name: 'Rendang Satset',
    category: t("for_your_travels"),
    price: 65000,
    image: 'homepict2.png',
    description: t("beef_rendang_in_singleserving_sachets_convenient_for_travelling"),
    cutout: true
  }, {
    id: 'telur',
    name: t("egg_rendang"),
    category: t("for_every_day"),
    price: 25000,
    image: 'homepict3.png',
    description: t("minangkabaustyle_egg_rendang_a_flavourful_addition_to_any_meal"),
    cutout: true
  }, {
    id: 'crackers',
    name: 'Rendang Crackers',
    category: t("for_a_little_break"),
    price: 15000,
    image: 'homepict4.png',
    description: t("the_flavour_of_rendang_in_savoury_crunchy_crackers"),
    cutout: true
  }, {
    id: 'pasta',
    name: t("rendang_paste"),
    category: t("for_home_cooking"),
    price: 35000,
    image: 'homepict5.png',
    description: t("readytoeat_rendang_paste_for_eggs_bread_noodles_and_your"),
    cutout: true
  }].map(p => ({
    ...p,
    src: asset(p.image)
  }));
}
export const rupiah = (n, language = 'id') => new Intl.NumberFormat(language === 'en' ? 'en-ID' : 'id-ID', {
  style: 'currency',
  currency: 'IDR',
  maximumFractionDigits: 0
}).format(n);
